import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen px-6 bg-background-50">
      <div className="text-center max-w-md">
        <span className="inline-block text-xs tracking-[0.2em] text-primary-500 font-medium mb-6 px-4 py-2 border border-primary-200/50 rounded-full">
          清文華泉事業有限公司
        </span>
        <div className="text-[9rem] md:text-[12rem] font-black text-background-200 select-none leading-none mb-4">
          404
        </div>
        <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
          找不到此頁面
        </h1>
        <p className="text-sm text-foreground-500 leading-relaxed mb-8">
          您所尋找的頁面不存在或已被移動。請返回首頁探索清文華泉事業有限公司的品牌內容與出版主題。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首頁
        </Link>
      </div>
    </div>
  );
}